<template>
  <div id="mapa" style="height: 500px;"></div>
</template>

<script>
import { LMap, LTileLayer, LMarker, L } from "vue2-leaflet";

export default {
  name: "mapa",
  bodyClass: "mapa",
  components: {
    L,
    LMap,
    LTileLayer,
    LMarker
  },
  data() {
    return {
      seccionales: []
    };
  },
  async created() {
    let res = await this.$osapm().get("misc/getSeccionales");

    //let res = await this.axios.get("mock/seccionales.json");

    this.seccionales = res.data;

    var mymap = L.map("mapa").setView([-34.6037, -58.3816], 5);

    L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      maxZoom: 18,
      id: "mapbox.streets"
    }).addTo(mymap);

    this.seccionales.forEach(x => {
      var marker = L.marker([x.SeccionalLatitud, x.SeccionalLongitud]).addTo(
        mymap
      );
      marker.bindPopup(
        "<b>SECCIONAL " +
          x.SeccionalNombre +
          "</b>" +
          "<br>" +
          x.SeccionalDomicilio +
          "<br>" +
          x.SeccionalLocalidadNombre +
          ", " +
          x.SeccionalProvinciaNombre +
          ". CP:" +
          x.SeccionalCodigoPostal +
          "<br>Horario " +
          x.SeccionalHorarios +
          "<br>Email: " +
          x.SeccionalEmail +
          ". <br>Tel: " +
          x.SeccionalTelefono
      );
    });
  }
};
</script>
<style>
</style>
